import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { Link } from "gatsby"
import { useIntl } from "react-intl";
import style from './index.module.less'
import { XrealLogoBlack, ShopIconWhite, XrealLogoWhite } from '@/images/index'
import getCountry from '@/utils/getCountry.js'
import { LearnBuyBtn2 } from "@/new_components"


const NormalMenu = ({
  getLinkUrl, 
  shopUrl, 
  guidesList, 
  categoriesList, 
  productsAll,
  dontfixed, 
  ifShowLocalNav,
  cusBackgroundColor = 'rgba(255,255,255,1)',
  cusBackdropFilter = 200,
  headerTextBlack = true
}) => {
  const intl = useIntl()
  const region = getCountry()
  const headerRef = useRef()
  const menuRef = useRef(null)
  const [hoverSubmenu, setHoverSubmenu] = useState(false)
  const [hoverPro, setHoverPro] = useState(false)
  const [ifSubMenuShow, setIfSubMenuShow] = useState(false)
  const [categoriesId, setCategoriesId] = useState(1)
  const [categoriesKey, setCategoriesKey] = useState('mostPopular')
  const linkState = { referrer: window.location.pathname }

  const showProducts = (key, id) => {
    setTimeout(() => {
      setCategoriesId(id)
      setCategoriesKey(key)
    }, 100)
  }

  useEffect(() => {
      if (!hoverPro && !hoverSubmenu) {
        setIfSubMenuShow(false)
      } else {
        setIfSubMenuShow(true)
      }
  }, [hoverPro, hoverSubmenu])

    useEffect(() => {
      if (!ifShowLocalNav) return

      document.body.style.overflow = 'auto'
      window.addEventListener("scroll", handleScroll)
      return () => {
          window.removeEventListener("scroll", handleScroll)
      }
    }, [])

    let lastScrollTop = 0;
    const handleScroll = () => {
        const currentScrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        const scrollDistance = currentScrollTop - lastScrollTop
        lastScrollTop = currentScrollTop;
        const whentohide = 200
        if (scrollDistance > 0 && currentScrollTop >= whentohide) {
          menuRef.current.style.opacity = '0'
          headerRef.current.style.transform = `translateY(-100%)`
        } else if ((currentScrollTop < whentohide) || !dontfixed) {
          menuRef.current.style.opacity = '1'
          headerRef.current.style.transform = `translateY(0)`
        }
    }

  const isHeaderLogoBlack = headerTextBlack || ifSubMenuShow
  const isHeaderTxtBlack = !headerTextBlack && !ifSubMenuShow


  return (
    <div className={style.menu} style={{
      boxShadow: ifSubMenuShow ? 'rgba(0, 0, 0, 0.1) 0px 0px 10px 0px' : 'none',
      backgroundColor: ifSubMenuShow ? 'rgba(245, 245, 245, 1)' : cusBackgroundColor,
      backdropFilter: `blur(${cusBackdropFilter})`,
      position: "fixed"
    }}
    ref={headerRef}>
      <div className={style.normalMenuHeader} ref={menuRef}>
        <Link to={getLinkUrl("/")} style={{display: 'flex'}}>
          {isHeaderLogoBlack ? <XrealLogoBlack /> : <XrealLogoWhite />}
        </Link>
        

        <div className={style.headerGuides}>
          {guidesList.filter((gItem)=>!gItem?.hidden).map((gItem) => (
            (gItem.link ? 
              <Link
                to={gItem.link}
                key={gItem.id} 
                state={linkState} 
                className={classNames(style.guidesItem, isHeaderTxtBlack && style.guidesItemWhite)}
              >
                <div
                  style={{
                    color: isHeaderTxtBlack && "#fff"
                  }}>
                    {gItem.title}
                  </div>
              </Link> : <div 
                  style={{ 
                    color: isHeaderTxtBlack && "#fff"
                  }}
                  key={gItem.id}
                  className={`${style.guidesItem}`} 
                  onMouseEnter={() => {
                    setHoverPro(true)
                  }}
                  onMouseLeave={() => {
                    setHoverPro(false)
                  }}
                >{gItem.title}</div>
            )
            
          ))}
        </div>

        <a href={shopUrl} target='_blank' className={style.shop}>
          <ShopIconWhite className={style.shopIcon} />
          <div> {intl.formatMessage({ id: "headernew_shop" })}</div>
        </a>

      </div>

        
      <div className={style.line} style={{ opacity: ifSubMenuShow ? '1' : '0' }}></div>

      <div className={style.subMenuBox}
        onMouseEnter={() => setHoverSubmenu(true)}
        onMouseLeave={() => {
          showProducts('mostPopular', 1);
          setHoverSubmenu(false);
          setCategoriesKey("mostPopular");
        }}
        style={{ height: ifSubMenuShow ? '692px' : '0', opacity: ifSubMenuShow ? '1' : '0' }}
      >
        <div className={style.categories}>
          <div>
            <div className={style.categoriesTitle}>{intl.formatMessage({ id: "categories_title" })}</div>
            <div className={style.categoriesList}>
              {categoriesList.map((cItem) => (
                <div 
                  key={cItem.id}
                  className={`${style.categoriesItem} ${categoriesId == cItem.id ? style.categoriesItemActivied : ''}`}
                  onMouseEnter={() => showProducts(cItem.key, cItem.id)}
                >{cItem.title}</div>
              ))}
            </div>
          </div>

          {region!=='kr' &&
            <LearnBuyBtn2 link={'/glasses/compare'} link_out={false} btnText={intl.formatMessage({ id: "air2.process.title13" })} />
          }
          
        </div>
        
        <div className={style.products}>
          {productsAll[categoriesKey].map((pItem) => (
            <Link to={getLinkUrl(pItem.link)} key={pItem.id} state={linkState}>
              <div className={style.productItem}>
                <div>
                  <img src={pItem.img} alt={pItem.title} />
                </div>
                <div className={style.productItemName}>{pItem.title}</div>
                <div className={style.productItemDesc}>{intl.formatMessage({ id: pItem.desc })}</div>
              </div>
            </Link>
          ))}
          
        </div>
      </div>
        
    </div>
  )
}

export default NormalMenu
